var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 34.7999C15.7938 34.7999 13.6092 34.3654 11.5709 33.5211C9.53266 32.6768 7.68064 31.4394 6.12062 29.8793C4.56059 28.3193 3.32312 26.4673 2.47884 24.429C1.63456 22.3908 1.20001 20.2062 1.20001 18C1.20001 15.7937 1.63456 13.6091 2.47884 11.5709C3.32312 9.5326 4.56059 7.68058 6.12062 6.12056C7.68064 4.56053 9.53266 3.32305 11.5709 2.47877C13.6092 1.6345 15.7938 1.19995 18 1.19995C22.4556 1.19995 26.7288 2.96995 29.8794 6.12056C33.03 9.27117 34.8 13.5443 34.8 18C34.8 22.4556 33.03 26.7287 29.8794 29.8793C26.7288 33.03 22.4556 34.7999 18 34.7999ZM18 34.7999V15.6C18 14.3269 18.5057 13.106 19.4059 12.2058C20.3061 11.3057 21.527 10.8 22.8 10.8H24M12 20.4H24",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.68375c26f1d760cc3ea741bcb5dc774b.svg";
export { ForwardRef as ReactComponent };